import styled from "@emotion/native";

import Text from "../../components/Text";

export const Container = styled.View(
    {
        paddingHorizontal: 13,
    },
    ({ isDisabled }: any) => {
        if (isDisabled) {
            return {
                opacity: 0.5,
            };
        }

        return {};
    },
);

export const Item = styled.TouchableOpacity({
    flexDirection: "row",
    marginBottom: 37,
});

export const Hero = styled.View({
    height: 85,
    width: 110,
    marginRight: 10,
});

export const HeroImage = styled.Image({
    flex: 1,
    resizeMode: "cover",
    height: 85,
    width: 110,
});

export const HeroOverlay = styled.View({
    position: "absolute",
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
});

export const Copy = styled.View({
    flexDirection: "column",
    justifyContent: "space-between",
    paddingBottom: 1,
    flex: 1,
});

export const Title = styled(Text)({
    marginBottom: 10,
});

export const Prefix = styled(Text)({
    marginTop: 0,
    textAlign: "left",
});

export const Summary = styled(Text)({
    textAlign: "left",
});

export const Caption = styled(Text)({});

export const AnswerCount = styled(Text)({});
